<template>
  <div class="home">
    <div class="nav-header">
      <div class="container">
        <div class="nav">
          <router-link to="/">
            <div class="logo">
              <img src="@/assets/512.png" alt="" />
              <div class="title">
                <h1>疾风清理大师</h1>
                <i class="iconfont icon-sousuo1x"></i>
              </div>
            </div>
          </router-link>
          <a href="#/" class="nav-item" @click="toggleActive('home')">
            <span :class="{ actived: activeClass == 'home' }">首页</span>
            <span class="sanjiao" v-if="activeClass == 'home'"></span>
          </a>
          <!-- <a href="#intro" class="nav-item" @click="toggleActive('intro')">
            <span :class="{ actived: activeClass == 'intro' }">介绍</span>
            <span class="sanjiao" v-if="activeClass == 'intro'"></span>
          </a> -->
        </div>
      </div>
    </div>
    <!-- <div style="height: 70px"></div> -->
    <div class="home-banner" id="top">
      <img src="@/assets/home.png" alt="" class="home_back" />
      <div class="container">
        <div class="content">
          <div class="phone">
            <img src="@/assets/1.png" alt="" />
          </div>
          <div class="right">
            <div class="header">疾风清理大师 
              <!-- <span class="downloadApp" @click="downloadApp">立即下载</span> -->
            </div>
            <div class="hint">一键清理扬声器灰尘，快速检测屏幕坏点，实时监测硬件信息，随时随地网络测速。<br/> 立即体验，让你的手机时刻保持最佳状态！</div>
          </div>
        </div>
      </div>
    </div>
    <div class="container" id="intro">
      <div class="img1">
        <div class="left">
          <div class="left-title">扬声器清灰</div>
          <div class="line"></div>
          <p>
            提供多种音波清理扬声器灰尘，告别沉闷破音，一键恢复澎湃音质！
          </p>
        </div>
        <div class="phone1">
          <img src="@/assets/2.png" alt="" />
        </div>
      </div>
      <div class="img2">
        <div class="phone2">
          <img src="@/assets/3.png" alt="" />
        </div>
        <div class="right">
          <div class="right-title">屏幕坏点检测</div>
          <div class="line"></div>
          <p style="width: 650px">提供多种纯色模式，检测屏幕是否有坏点、亮点和暗点，新机验屏/日常排查，坏点瑕疵无处遁形！</p>
        </div>
      </div>
      <div class="img1">
        <div class="left">
          <div class="left-title">免费网络测速</div>
          <div class="line"></div>
          <p>
            随时随地网络测速： 刷剧、游戏卡不卡？一键秒知网速快慢！
          </p>
        </div>
        <div class="phone1">
          <img src="@/assets/4.png" alt="" />
        </div>
      </div>
      <div class="img2">
        <div class="phone2">
          <img src="@/assets/5.png" alt="" />
        </div>
        <div class="right">
          <div class="right-title">隐私空间</div>
          <div class="line"></div>
          <p>
            提供设备安全存储空间，存放个人私密照片和视频，本地存储，不上传服务器。
          </p>
        </div>
      </div>
    </div>
    <div class="home_icon">
      <img src="@/assets/512.png" alt="" />
      <h4 style="font-weight: blod; font-size: 40px; margin-top: 20px">
        疾风清理大师
      </h4>
    </div>
    <div class="message">
      <div class="item">
        <h3>公司名称</h3>
        <p>庞赛（北京）科技有限公司</p>
      </div>
      <div class="item">
        <h3>公司地址</h3>
        <p>北京市朝阳区文化创意大厦C座2层</p>
      </div>
      <!-- <div class="item">
        <h3>商务合作</h3>
        <p></p>
      </div> -->
      <div class="item">
        <h3>客服QQ</h3>
        <p>2118789460</p>
      </div>
      <!-- <div class="item">
        <div class="privacy" @click="goPrivacy">隐私政策</div>
      </div> -->
    </div>
    <div class="banquan">
      <a href="https://timeyear.psaso.net/jifengqinglidashi/agreement/privacy_policy.html" target="_blank">隐私协议</a>
      <a href="https://timeyear.psaso.net/jifengqinglidashi/agreement/user_agreement.html" target="_blank">用户协议</a>
      <a href="https://timeyear.psaso.net/jifengqinglidashi/agreement/automatic_renewal_service_agreement.html" target="_blank">自动续费协议</a>
      <span style="cursor: pointer" @click="jumpOther"
        >© 庞赛（北京）信息科技有限公司 | 京ICP备19009253号-1</span
      >
    </div>
    <!--<div class="" id="join">
      <div class="message">
        <div class="item">
          <h3>客服邮箱</h3>
          <p>sbgrceone@outlook.com</p>
        </div>
      </div>
    </div>-->
  </div>
</template>

<script>
  export default {
    name: "home",
    components: {},
    data() {
      return {
        activeClass: "home",
      };
    },
    methods: {
      toggleActive(name) {
        this.activeClass = name;
      },
      goPrivacy() {
        this.$router.push("/privacy");
      },
      // 下载app
      downloadApp(){
        // location.href = "https://mallcdngn.oss-cn-beijing.aliyuncs.com/apk/greenleopard_1.0.0_release_06.09_kuai.apk";
        location.href = "https://mallcdn.playapper.top/apk/release/lbsjws.apk";
      },
      jumpOther() {
        window.open("https://beian.miit.gov.cn/#/Integrated/index");
      },
    },
    mounted() {
      let _this = this;
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
  };
</script>
<style scoped lang="less">
  .home {
    .banquan {
      width: 100%;
      min-width: 1200px;
      height: 80px;
      color: #fff;
      line-height: 80px;
      // font-size: 24px;
      background: rgba(37, 42, 52, 1);
      text-align: center;
      a{
        color:#fff;
        margin-right:10px;
      }
    }
    .container {
      width: 100%;
      min-width: 1200px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .logo-box {
        width: 100%;
        padding-top: 107px;
        .logo {
          width: 153px;
          height: 153px;
          background: url("../assets/512.png") no-repeat;
          background-size: 100%;
          margin: 0 auto;
        }
        h2 {
          font-size: 36px;
          margin-top: 30px;
          color: #333;
        }
        p {
          font-size: 20px;
          color: #999;
          margin-top: 10px;
        }
      }
      .img1 {
        width: 1200px;
        height: 900px;
        // margin-top: 140px;
        display: flex;
        align-items: center;
        .left {
          margin-right: 152px;
          display: flex;
          flex-direction: column;
          .left-title {
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            font-size: 50px;
            margin-top: 86px;
            text-align: left;
          }
          p {
            margin-top: 69px;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            line-height: 48px;
            font-size: 30px;
            text-align: left;
            width: 628px;
          }
        }
        .phone1 {
          // height: 100%;
          width: 394px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .line {
        width: 120px;
        height: 6px;
        background: #f3c33d;
        border-radius: 3px;
        margin-top: 26px;
      }
      .img2 {
        width: 1200px;
        height: 800px;
        // margin-top: 65px;
        display: flex;
        align-items: center;
        .phone2 {
          // height: 100%;
          width: 394px;

          margin-right: 146px;

          img {
            width: 100%;
            height: 100%;
          }
        }
        .right {
          display: flex;
          flex-direction: column;
          .right-title {
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            font-size: 50px;
            margin-top: 162px;
            text-align: left;
          }
          p {
            margin-top: 69px;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            line-height: 48px;
            font-size: 30px;
            text-align: left;
          }
        }
      }
      .img3 {
        width: 100%;
        height: 702px;
        margin-top: 138px;
        /*background: url("../assets/img3.png") no-repeat;
                                                                                                          background-size: 100%;*/
        display: flex;
        /*justify-content: space-between;*/
        .left {
          margin-right: 152px;
          display: flex;
          flex-direction: column;
          .left-title {
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            font-size: 50px;
            margin-top: 86px;
            text-align: left;
          }
          p {
            margin-top: 69px;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            line-height: 48px;
            font-size: 30px;
            text-align: left;
            width: 628px;
          }
        }
      }
    }
    .home-banner {
      width: 100%;
      min-width: 1200px;
      height: 900px;
      margin-top: 70px;
      position: relative;
      .home_back {
        width:100%;
        height: 100%;
        position: absolute;
        top: 0;
      }
      .container {
        position: relative;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        .content {
          display: flex;
          align-items: center;
          .phone {
            width: 394px;
            // height: 880px;

            margin-right: 150px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .right {
            color: #fff;
            text-align: left;
            .header {
              font-weight: 600;
              font-size: 80px;
              //line-height: 38px;
            }
            .hint {
              width:700px;
              font-size: 36px;
              margin-top: 29px;
            }
            .btn {
              width: 330px;
              height: 100px;
              border: 3px solid #fff;
              font-size: 40px;
              font-weight: 500;
              line-height: 94px;
              text-align: center;
              border-radius: 50px;
              margin-top: 56px;
              color: #fff;
              padding: 0;
              &:hover {
                color: #fff;
              }
            }
          }
        }
      }
    }
    .nav-header {
      height: 70px;
      width: 100%;
      position: fixed;
      top: 0;
      display: flex;
      justify-content: center;
      background: #fff;
      color: #333333;
      z-index: 9;
      .container {
        width: 1200px;
      }
      .nav {
        width: 100%;
        height: 70px;
        display: flex;
        align-items: center;
        .logo {
          display: flex;
          align-items: center;
          img {
            width: 40px;
            height: 40px;
            margin-right: 7px;
          }
          .title {
            h1 {
              display: inline-block;
              color: #000;
              font-weight: bold;
              font-size: 26px;
              margin-right: 13px;
            }
            span {
              display: inline-block;
              color: #999999;
              font-size: 18px;
            }
          }
        }
        .nav-item {
          cursor: pointer;
          text-align: center;
          height: 70px;
          line-height: 70px;
          font-size: 18px;
          display: flex;
          align-items: center;
          position: relative;
          padding: 0 30px;
          color: #333;
          -webkit-touch-callout: none; /* iOS Safari */
          -webkit-user-select: none; /* Chrome/Safari/Opera */
          -khtml-user-select: none; /* Konqueror */
          -moz-user-select: none; /* Firefox */
          -ms-user-select: none; /* Internet Explorer/Edge */
          user-select: none; /* Non-prefixed version, currently not supported by any browser */
          text-decoration: none;
          &:hover {
            // color: #f3c33d;
          }
          span {
            cursor: pointer;
            padding-top: 5px;
            &.actived {
              // color: #f3c33d;
            }
          }
          .sanjiao {
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            height: 11px;
            width: 29px;
            // background: url("../assets/img1.png") no-repeat;
            background-size: 100%;
          }
        }
      }
    }
    .home_icon {
      width: 100%;
      min-width: 1200px;
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        width: 194px;
        height: 194px;
        margin-top: 105px;
      }
    }
    .message {
      margin-top: 114px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(37, 42, 52, 1);
      height: 140px;
      .item {
        text-align: center;
        margin-right: 100px;
        .privacy {
          color: #ffffff;
          font-size: 20px;
          text-decoration: underline;
          cursor: pointer;
        }
        &:last-child {
          margin-right: 0;
        }
        h3 {
          font-size: 24px;
          color: #fff;
          font-weight: 500;
        }
        p {
          font-size: 18px;
          color: #fff;
          margin-top: 17px;
        }
      }
    }
  }
  .downloadApp{
    font-size:25px;
    padding:5px 10px;
    border-radius:5px;
    color:#fff;
    background:#02cf68;
    cursor: pointer;
  }
</style>




// WEBPACK FOOTER //
// src/components/HelloWorld.vue